import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function NavBar({ account }) {
  const navigate = useNavigate();

  if (!account && window.location.pathname === '/') {
    return null
  }

  const handleChipClick = () => {
    navigate('/')
  };

  return (
    <Box
      sx={{
        zIndex: 1000,
        position: 'absolute',
        top: 10,
        left: 10,
      }}
    >
      <Typography
            variant="h5"
            component="div"
            sx={{ 
              flexGrow: 1,
              fontWeight: 'bold',
              cursor: 'pointer',
              textShadow: ' -2px -2px 0 #fff, 2px -2px 0 #fff, -2px 2px 0 #fff, 2px 2px 0 #fff' 
            }}
            color="primary"
            onClick={handleChipClick}
          >
            navscout
          </Typography>
    </Box>
  );
}
